// Icons.js

export const getIconByKey = (iconsByKey, iconKey) => {
  if (!iconKey || !iconsByKey) return null;
  return iconsByKey[iconKey] || null;
};

export const getIconPath = (iconsByKey, iconKey, fallbackPath) => {
  const icon = getIconByKey(iconsByKey, iconKey);
  const iconPath = typeof icon?.path === 'string' ? icon.path.trim() : '';

  if (iconPath) return iconPath;
  if (typeof fallbackPath === 'string' && fallbackPath.trim()) return fallbackPath.trim();
  return null;
};
